<template>
  <div class="content-header">
    <div class="d-flex align-items-center">
      <div class="me-auto">
        <h3 class="page-title">{{ $t('setting.settings') }}</h3>
        <div class="d-inline-block align-items-center">
          <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#"><i class="mdi mdi-home-outline"></i></a></li>
              <li :class="['breadcrumb-item', {'active': !title}]" aria-current="page">{{ $t('setting.service') }}</li>
              <li class="breadcrumb-item active" aria-current="page" v-if="title">{{ title }}</li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12">
      <router-link :class="'btn btn-sm me-3 ' +  ($route.name === 'settings_service_list' ?  'btn-primary' : 'btn-secondary')"
                   :to="{name: 'settings_service_list'}">รายการบริการ</router-link>
      <router-link :class="'btn btn-sm me-3 ' +  ($route.name === 'settings_service_category' ?  'btn-primary' : 'btn-secondary')"
                   :to="{name: 'settings_service_category'}">แผนก/กลุ่มบริการ</router-link>
      <router-link :class="'btn btn-sm me-3 ' +  ($route.name === 'settings_service_station' ?  'btn-primary' : 'btn-secondary')"
                   :to="{name: 'settings_service_station'}">จุดรับบริการ</router-link>
      <router-link :class="'btn btn-sm ' +  ($route.name === 'settings_service_unit' ?  'btn-primary' : 'btn-secondary')"
                   :to="{name: 'settings_service_unit'}">หน่วยนับบริการ</router-link>
    </div>
  </div>

  <router-view />
</template>

<script>
export default {
  computed: {
    title() {
      if (this.$route.name === 'settings_service_add')
        return 'Add';
      else if (this.$route.name === 'settings_service_edit')
        return 'Edit';

      return '';
    }
  }
}
</script>